import * as yup from "yup";

export const NorthCarolinaPastDueAnnualReportValidationSchema = yup.object().shape({
  // add proper validation for NC
  iAmAuthorized: yup.bool().required().oneOf([true], "Must be checked"),
  annualAgree: yup.bool().required().oneOf([true], "Must be checked"),

  electronicSignature: yup.string().required("Required"),
  title: yup.string().required("Required"),
  signerAddress: yup.object().shape({
    address: yup.string().required('Required'),
    city: yup.string().required('Required'),
    state: yup.string().required('Required'),
    zip: yup.string().required('Required'),
  }),
});


export const StateAnnualPastDueValidation: any = {
//   Florida: FloridaAnnualReportValidationSchema,
//   Georgia: GeorgiaAnnualReportValidationSchema,
//   Indiana: IndianaAnnualReportValidationSchema,
//   Mississippi: MississippiAnnualReportValidationSchema,
//   Montana: MontanaAnnualReportValidationSchema,
  "North Carolina": NorthCarolinaPastDueAnnualReportValidationSchema,
//   Tennessee: TennesseeAnnualReportValidationSchema,
//   Virginia: VirginiaAnnualReportValidationSchema,
};
